const Badge = ({ color = "primary", children, className = "" }) => {
  return (
    <span
      className={`badge text-${color}-600 bg-${color}-100 radius-4 ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
